Vue.component('v-events', {
  props: ['month', 'year'],
  data: function () {
    return {
      months: [
        {
          name: 'Январь',
          num: '01'
        },
        {
          name: 'Февраль',
          num: '02'
        },
        {
          name: 'Март',
          num: '03'
        },
        {
          name: 'Апрель',
          num: '04'
        },
        {
          name: 'Май',
          num: '05'
        },
        {
          name: 'Июнь',
          num: '06'
        },
        {
          name: 'Июль',
          num: '07'
        },
        {
          name: 'Август',
          num: '08'
        },
        {
          name: 'Сентябрь',
          num: '09'
        },
        {
          name: 'Октябрь',
          num: '10'
        },
        {
          name: 'Ноябрь',
          num: '11'
        },
        {
          name: 'Декабрь',
          num: '12'
        }
      ],
      years: [],
      monthOpened: false,
      yearOpened: false
    }
  },
  mounted: function () {
    var self = this
    this.years = this.getYears();

    $(this.$el).find('.events__calendar #calendar').datetimepicker({
      inline: true,
      viewMode: 'days',
      format: 'DD/MM/YYYY',
      locale: 'ru',
      defaultDate: new Date(self.year, self.month-1, 1)
  }).on('dp.update', self.highlightDate);

    $(this.$el).find('.events__calendar .prev').html('<svg width="11" height="18"><use xlink:href="#svg-arrow-prev-cal1-icon" /></svg>');
    $(this.$el).find('.events__calendar .next').html('<svg width="11" height="18"><use xlink:href="#svg-arrow-next-cal1-icon" /></svg>');
    this.highlightDate();

    $(this.$el).find('.next').click(function () {
      if(self.month >= 12){
        document.location.href='/events/'+(self.year+1)+'/1';
      }else{
        document.location.href='/events/'+self.year+'/'+(self.month+1);
      }
      return false;
    });
    $(this.$el).find('.prev').click(function () {
      if(self.month <= 1){
        document.location.href='/events/'+(self.year-1)+'/12';
      } else {
        document.location.href='/events/'+self.year+'/'+(self.month-1);
      }
      return false;
    });
    $(this.$el).find('.datepicker .day').click(function() {
      return false
    })
    $(this.$el).find('.datepicker .picker-switch').click(function() {
      return false
    })

    $(this.$el).find('.datepicker .day.highlight').click(function() {
      var url_arr = $(this).attr('data-day').split('.')

      document.location.href =
        '/events/' + url_arr[2] + '/' + url_arr[1] + '/' + url_arr[0]
      return false
    })

    $(this.$el).find('.events__select-scroll[data-scroll]').slimScroll({
      height: '300px',
      size: '3px',
      color: '#C4C4C4'
    });
  },
  methods: {
    onClickOutsideMonths: function () {
      this.monthOpened = false
    },
    onClickOutsideYears: function () {
      this.yearOpened = false
    },
    toggleMonth: function () {
      this.monthOpened = !this.monthOpened
    },
    toggleYear: function () {
      this.yearOpened = !this.yearOpened
    },
    highlightDate: function () {
      var self = this
      var daysString = $(this.$el).find('#calendar').data('day');
      var current = $(this.$el).find('#calendar').data('cur');
      var days = [];
      if (daysString) {
        days = daysString.split(',');
        $.each(days, function (index, item) {
          $(self.$el).find('#calendar td[data-day="' + item + '"]').addClass('highlight');
        });
      }

      if (current) {
        $(self.$el).find('#calendar td[data-day="' + current + '"]').addClass('current');
      }
    },
    getYears: function () {
      var years = [];
      var curYear = new Date().getFullYear();
      var times = 5;
      for(var i = 0; i < times; i++){
        years.push(curYear-i)
      }
      return years
    }
  }
})
